module.exports = __webpack_public_path__ + "static/media/S2N6-5.f411661e.svg";